import { AddProjectsToFolder } from '@/connection/projects/add-projects-to-folder';
import { serializeError } from '@/store/utils/serialize-error';
import { EventGroupAssociation } from '@/types/projects.types';
import { ProjectsReducerCreator } from '../types';

const addProjectsToGroupReducer = (create: ProjectsReducerCreator) => {
  return create.asyncThunk(
    async (
      { channel, groupUuid, projectUuids }: { channel: number; groupUuid: string; projectUuids: string[] },
      { rejectWithValue }
    ) => {
      try {
        const response = await AddProjectsToFolder({ channel, groupUuid, eventUuids: projectUuids });
        return response;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (state.projectGroups) {
          const groupUuid = action.payload[0].group_uuid;
          const eventUuids = action.payload.map((ega: EventGroupAssociation) => ega.event_uuid);

          return {
            ...state,
            addProjectsToGroup: [],
            eventGroups: state.projectGroups.map((pg) =>
              pg.uuid === groupUuid ? { ...pg, event_uuids: [...pg.event_uuids, ...eventUuids] } : pg
            ),
          };
        } else {
          return state;
        }
      },
    }
  );
};

export default addProjectsToGroupReducer;
